import { useUiConfig } from 'api/uiConfig/uiConfig.api'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { TIME_SERIES_VISUALIZATION } from './constants'

/**
 * Whether the user may create and edit time series settings on the active system. Time series
 * charts and tables do not work at all without the system's time series visualization ui config,
 * so the permission alone is not enough.
 */
export function useTimeSeriesSettingAccess(): boolean {
  const { hasAccess, systemId } = useAuth()
  const timeSeriesVisualization = useUiConfig(systemId, TIME_SERIES_VISUALIZATION)

  return (
    hasAccess({ submodule: 'optimizesettings_time_series', module: 'optimizesettings' }) &&
    !!timeSeriesVisualization?.data?.length
  )
}
